import { render } from "./communityofMinisters.vue?vue&type=template&id=2927399e&scoped=true"
import script from "./communityofMinisters.vue?vue&type=script&lang=js"
export * from "./communityofMinisters.vue?vue&type=script&lang=js"

import "./communityofMinisters.vue?vue&type=style&index=0&id=2927399e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2927399e"]])

export default __exports__